export var onboardingCategories = {
  challenge: 'Challenge Onboarding',
  standard: 'Standard Onboarding'
};
export var modalPages = {
  welcome: 'Welcome Screen',
  profile: 'Fill Out Your Profile'
};
export var challengePages = {
  completion: 'Challenge Completion Screen',
  welcome: 'Welcome Page'
};
export { statusUpdateFailure } from './welcome-message-flow/onboarding-profile-form/alerts';
export { updateOnboardingStatus } from './welcome-message-flow/onboarding-profile-form/mutations';